import { TESTS_ROUTES } from '../../constants/_routes'
import testsTypes from '../../constants/testsTypes'
import { axios } from '../../services'

// INDEX
const tests_xlsx_request = () => {
  return {
    type: testsTypes.xlsx.request
  }
}

const tests_xlsx_success = () => {
  return {
    type: testsTypes.xlsx.success
  }
}

const tests_xlsx_failure = (messages) => {
  return {
    type: testsTypes.xlsx.failure,
    payload: messages
  }
}

const tests_xlsx = (filters={}, sort="", order="") => {
  return function (dispatch) {
    // Before Request
    dispatch(tests_xlsx_request())
    document.body.classList.add('instalevel-fetching-data')

    axios.get(
      `${TESTS_ROUTES.index}.xlsx`,
      {
        params: {
          sort: sort,
          order: order,
          filters: filters
        },
        responseType: 'blob'
      }
    ).then( response => {
      // success
      const blob = URL.createObjectURL(response.data, "mitsos")
      let fileLink = document.createElement('a')
      document.body.appendChild(fileLink);
      fileLink.style="display: none"
      fileLink.href = blob
      fileLink.download = "tests.xlsx"
      fileLink.click();
      URL.revokeObjectURL(blob)
      dispatch( tests_xlsx_success() )
      document.body.classList.remove('instalevel-fetching-data')
    }).catch( error=> {
      // failure
      document.body.classList.remove('instalevel-fetching-data')
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching xlsx file."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( tests_xlsx_failure(errors))
    })
  }
}

export {
  tests_xlsx
}



// WEBPACK FOOTER //
// ./src/js/actions/tests/getxlsx.js